import { render, staticRenderFns } from "./Form.Modal.vue?vue&type=template&id=36177c2d"
import script from "./Form.Modal.vue?vue&type=script&lang=js"
export * from "./Form.Modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports